// extracted by mini-css-extract-plugin
export default {"box":"company_box__obLyz","img":"company_img__EJ4UR","logobox":"company_logobox__nSF5x"};